export default {
    cn: {
        profitShareReport: {
            title: '分成报表',
            search: '搜索',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            nodata: "没有查询到数据",
            downloadExcelForms: "下载 Excel",
            begin: '编号区间：',
            to: '到',
            selectArr: [
                { label: '账号', value: 'LOGIN' },
                { label: '代理账号', value: 'TO_ACC' },
            ],
            first_row: [
                { key: 'REPORT_ID', name: '编号' },
                // { key: 'APPLICATION_DATE', name: '申请日期' },
                { key: 'DATE_FROM', name: '开始日期' },
                { key: 'DATE_TO', name: '结束日期' },
                { key: 'LOGIN', name: '账号' },
                { key: 'TO_ACC', name: '代理账号' },
                { key: 'PERCENTAGE', name: '百分比' },
                { key: 'TOTAL_PL', name: '总盈亏' },
                { key: 'SHARE_PL', name: '分成利润' },
                { key: 'CALC_CLOSED_PL', name: '平仓盈亏' },
                { key: 'CALC_FIRST_FLOATING_PL', name: '开始计算时未平仓盈亏' },
                { key: 'CALC_LAST_FLOATING_PL', name: '结束计算后未平仓盈亏' },
                { key: 'CALC_FIRST_EQUITY', name: '开始计算时净值' },
                { key: 'CALC_LAST_EQUITY', name: '结束计算后净值' },
                { key: 'CALC_TOTAL_DEPOSIT', name: '总入金' },
                { key: 'CALC_TOTAL_WITHDRAWAL', name: '总出金' },
                { key: 'CALC_TOTAL_CREDIT', name: '总信贷' },
                { key: 'SHARE_AMOUNT_METHOD1', name: '方法一分成' },
                { key: 'SHARE_AMOUNT_METHOD2', name: '方法二分成' }
            ]
        }
    },
    hk: {
        profitShareReport: {
            title: '分成報表',
            search: '搜索',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            nodata: "沒有查詢到數據",
            downloadExcelForms: "下載 Excel",
            begin: '編號區間：',
            to: '到',
            selectArr: [
                { label: '賬號', value: 'LOGIN' },
                { label: '代理賬號', value: 'TO_ACC' },
            ],
            first_row: [
                { key: 'REPORT_ID', name: '編號' },
                { key: 'DATE_FROM', name: '開始日期' },
                { key: 'DATE_TO', name: '結束日期' },
                { key: 'LOGIN', name: '賬號' },
                { key: 'TO_ACC', name: '代理賬號' },
                { key: 'PERCENTAGE', name: '百分比' },
                { key: 'TOTAL_PL', name: '總盈虧' },
                { key: 'SHARE_PL', name: '分成利潤' },
                { key: 'CALC_CLOSED_PL', name: '平倉盈虧' },
                { key: 'CALC_FIRST_FLOATING_PL', name: '開始計算時未平倉盈虧' },
                { key: 'CALC_LAST_FLOATING_PL', name: '結束計算後未平倉盈虧' },
                { key: 'CALC_FIRST_EQUITY', name: '開始計算時淨值' },
                { key: 'CALC_LAST_EQUITY', name: '結束計算後淨值' },
                { key: 'CALC_TOTAL_DEPOSIT', name: '總入金' },
                { key: 'CALC_TOTAL_WITHDRAWAL', name: '總出金' },
                { key: 'CALC_TOTAL_CREDIT', name: '總信貸' },
                { key: 'SHARE_AMOUNT_METHOD1', name: '方法一分成' },
                { key: 'SHARE_AMOUNT_METHOD2', name: '方法二分成' }
            ]
        }
    },
    en: {
        profitShareReport: {
            title: 'Profit Share Report',
            search: 'Search',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            nodata: "No data found",
            downloadExcelForms: "Download Excel",
            begin: 'Report ID Interval：',
            to: 'To',
            selectArr: [
                { label: 'Login', value: 'LOGIN' },
                { label: 'IB Account', value: 'TO_ACC' },
            ],
            first_row: [
                { key: 'REPORT_ID', name: 'Report ID' },
                { key: 'DATE_FROM', name: 'Date From' },
                { key: 'DATE_TO', name: 'Date To' },
                { key: 'LOGIN', name: 'Login' },
                { key: 'TO_ACC', name: 'IB Account' },
                { key: 'PERCENTAGE', name: 'Percentage' },
                { key: 'TOTAL_PL', name: 'Total PL' },
                { key: 'SHARE_PL', name: 'Share PL' },
                { key: 'CALC_CLOSED_PL', name: 'Closed PL' },
                { key: 'CALC_FIRST_FLOATING_PL', name: 'First Floating PL' },
                { key: 'CALC_LAST_FLOATING_PL', name: 'Last Floating PL' },
                { key: 'CALC_FIRST_EQUITY', name: 'First Equity' },
                { key: 'CALC_LAST_EQUITY', name: 'Last Equity' },
                { key: 'CALC_TOTAL_DEPOSIT', name: 'Total Deposit' },
                { key: 'CALC_TOTAL_WITHDRAWAL', name: 'Total Withdrawal' },
                { key: 'CALC_TOTAL_CREDIT', name: 'Total Credit' },
                { key: 'SHARE_AMOUNT_METHOD1', name: 'Share Amount Method1' },
                { key: 'SHARE_AMOUNT_METHOD2', name: 'Share Amount Method2' }
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/MultiLanguage/ProfitShareSetting/profitShareReport.js